// extracted by mini-css-extract-plugin
module.exports = {"wrujtsv":"wrujtsv"};